import { render, staticRenderFns } from "./collateral-build-widget.vue?vue&type=template&id=592b7d5e&"
import script from "./collateral-build-widget.vue?vue&type=script&lang=js&"
export * from "./collateral-build-widget.vue?vue&type=script&lang=js&"
import style0 from "./collateral-build-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
